import { css } from 'styled-components';

import reset from './reset';
import { proximaNovaSoft, proximaNova } from './font';
import { baseText } from './text';

export default css`
	// Reset css
	${reset};
	
	// Fonts
	${proximaNovaSoft};
	${proximaNova};

	html {
		scroll-behavior: smooth;
	}
	
	html, body {
		${baseText};
	}
	
	.clear-last-empty {
		> *:last-child:empty {
			display: none;
		}
	}
	
	/* Change the white to any color ;) */
	input:-webkit-autofill,
	input:-webkit-autofill:hover, 
	input:-webkit-autofill:focus, 
	input:-webkit-autofill:active  {
	    -webkit-box-shadow: 0 0 0 30px white inset !important;
	}
`;
